"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.models = exports.updatePickupCalendar = exports.createPickupCalendar = exports.deletePickupCalendar = exports.generatePickups = exports.previewPickups = exports.getPickupCalendar = exports.deleteWorkingDaysCalendar = exports.updateWorkingDaysCalendar = exports.createWorkingDaysCalendar = exports.getHolidays = exports.previewWorkingDays = exports.getWorkingDays = exports.getWorkingDaysCalendar = void 0;
const axios_1 = require("axios");
const moment = require("moment");
const models = require("../models/calendars/calendar-models.v0");
exports.models = models;
const shared_1 = require("./shared");
const ymdDateFormat = 'YYYY-MM-DD';
exports.getWorkingDaysCalendar = async (authorization, correlationId, calendarId) => {
    try {
        return (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars/${calendarId}`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
};
exports.getWorkingDays = async (authorization, correlationId, calendarId, startDate, endDate) => {
    try {
        return (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars/${calendarId}/days`, {
            params: {
                startDate: moment(startDate).format(ymdDateFormat),
                endDate: moment(endDate).format(ymdDateFormat),
            },
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
};
exports.previewWorkingDays = async (authorization, correlationId, workingDaysCalendar, startDate, endDate) => {
    return (await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars/preview`, workingDaysCalendar, {
        params: {
            startDate: moment(startDate).format(ymdDateFormat),
            endDate: moment(endDate).format(ymdDateFormat),
        },
        headers: shared_1.getHeaders(authorization, correlationId),
    })).data;
};
exports.getHolidays = async (authorization, correlationId, holidayUrl, startDate, endDate) => {
    return (await axios_1.default.get(holidayUrl, {
        params: {
            startDate: moment(startDate).format(ymdDateFormat),
            endDate: moment(endDate).format(ymdDateFormat),
        },
        headers: shared_1.getHeaders(authorization, correlationId),
    })).data;
};
exports.createWorkingDaysCalendar = async (authorization, correlationId, calendar) => {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars`, calendar, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.location.split('/').pop();
};
exports.updateWorkingDaysCalendar = async (authorization, correlationId, calendarId, etag, patch) => {
    const headers = Object.assign(Object.assign({}, shared_1.getHeaders(authorization, correlationId)), { 'if-match': etag });
    const response = await axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars/${calendarId}`, patch, {
        headers,
    });
    return response.headers.ETag;
};
exports.deleteWorkingDaysCalendar = async (authorization, correlationId, calendarId) => {
    await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/workingDaysCalendars/${calendarId}`, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
};
exports.getPickupCalendar = async (authorization, correlationId, calendarId) => {
    try {
        return (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/pickupCalendars/${calendarId}`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
};
exports.previewPickups = async (authorization, correlationId, pickupCalendar, startDateTime, endDateTime) => {
    return (await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/pickupCalendars/preview`, pickupCalendar, {
        params: {
            startDateTime: moment(startDateTime).toISOString(),
            endDateTime: moment(endDateTime).toISOString(),
        },
        headers: shared_1.getHeaders(authorization, correlationId),
    })).data;
};
exports.generatePickups = async (authorization, correlationId, pickupCalendarId, startDateTime, endDateTime) => {
    return (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/pickupCalendars/${pickupCalendarId}/pickups`, {
        params: {
            startDateTime: moment(startDateTime).toISOString(),
            endDateTime: moment(endDateTime).toISOString(),
        },
        headers: shared_1.getHeaders(authorization, correlationId),
    })).data;
};
exports.deletePickupCalendar = async (authorization, correlationId, calendarId) => {
    await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/pickupCalendars/${calendarId}`, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
};
exports.createPickupCalendar = async (authorization, correlationId, calendar) => {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/pickupCalendars`, calendar, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.location.split('/').pop();
};
exports.updatePickupCalendar = async (authorization, correlationId, id, etag, patch) => {
    const headers = Object.assign(Object.assign({}, shared_1.getHeaders(authorization, correlationId)), { 'if-match': etag });
    const response = await axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/pickupCalendars/${id}`, patch, {
        headers,
    });
    return response.headers.ETag;
};
//# sourceMappingURL=calendars.v0.js.map